// extracted by mini-css-extract-plugin
module.exports = {"container":"CI-z","modal":"DI-z"};